import { render, staticRenderFns } from "./TimeNow.vue?vue&type=template&id=76ab64b5&scoped=true"
import script from "./TimeNow.vue?vue&type=script&lang=js"
export * from "./TimeNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ab64b5",
  null
  
)

export default component.exports